document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.result__tab').forEach(el => el.addEventListener('click', function (e) {
        const element = (this)
        const num = element.getAttribute('round')
        element.closest('.result__tabs').querySelectorAll('.result__tab').forEach(el => (el).classList.remove('active'))
        element.closest('.result').querySelectorAll('.result__tab-container').forEach(el => (el).classList.remove('active'))
        element.classList.add('active')
        element.closest('.result').querySelector('.result__tab-container[round="' + num + '"]').classList.add('active')
    }))

    document.querySelectorAll('.result__tab-mobile').forEach(el => el.addEventListener('click', function (e) {
        const element = (this)
        const num = element.getAttribute('round')
        element.closest('.result__container-mobile').querySelectorAll('.result__tab-mobile').forEach(el => (el).classList.remove('active'))
        element.closest('.result__container-mobile').querySelectorAll('.result__tab-container-mobile').forEach(el => (el).classList.remove('active'))
        element.classList.add('active')
        element.closest('.result__container-mobile').querySelector('.result__tab-container-mobile[round="' + num + '"]').classList.add('active')
    }))

    document.querySelectorAll('.live__item-match').forEach(el => el.addEventListener('click', function (e) {
        const element = (this)
        const num = element.getAttribute('game')
        element.closest('.live__item-container').querySelectorAll('.live__item-match').forEach(el => (el).classList.remove('active'))
        element.classList.add('active')
        document.querySelector('.iframe-game').setAttribute('src', 'https://viewer.fide.com/widget/' + '' + num + '')
        $('.live__items-container-title').html($(this).find('.live__item-match-com').clone())
        $('.live__item-container').removeClass('active')
    }))

    document.querySelectorAll('.round-item').forEach(el => el.addEventListener('click', function (e) {
        const element = (this)
        const num = element.getAttribute('round')
        document.querySelectorAll('.round').forEach(el => (el).classList.remove('active'))
        document.querySelectorAll('.round-item').forEach(el => (el).classList.remove('active'))
        element.classList.add('active')
        document.querySelector('.round:nth-child(' + num + ')').classList.add('active')
    }))

    document.querySelector('.header__btn-mobile-menu').addEventListener('click', function () {
        (this).classList.toggle('active')
        document.querySelector('body').classList.toggle('fixed')
        document.querySelector('.header__items').classList.toggle('active')
    })

    $(document).ready(function() {
        $('.live__item-select').select2({
            minimumResultsForSearch: -1
        });
    });

    $('.live__items-container-title').on('click', function () {
        $('.live__item-container').toggleClass('active')
    })

    $(document).on('mousedown',function (e) {
        var container = $(".live__item-container")
        if (container.has(e.target).length === 0){
            $('.live__item-container').removeClass('active')
        }
    })
    
    $('.iframe-game__button').on('click', function () {
        $('.modal').addClass('active')
        $('body').addClass('fixed')
        $('.iframe-game').hide()
        $('.iframe-game-full-screen').attr('src', '' + $('.iframe-game').attr('src') + '')
    })
    $('.modal-btn-close').on('click', function () {
        $('.modal').removeClass('active')
        $('body').removeClass('fixed')
        $('.iframe-game').show()
        $('.iframe-game-full-screen').attr('src', '')
    })
})